export interface ErrorTemplate {
  name: string;
  message: string;
}

export class ValidationError implements ErrorTemplate {
  name: string;
  message: string;
  constructor(name: string, message: string) {
    this.name = name;
    this.message = message;
  }
}



// WEBPACK FOOTER //
// ./src/models/ErrorTemplate.ts